<script>
  export let state = "New York";
  export let rate = 0.0;

</script>

<div id="card" class="info">
  <div class="title">{state}</div>
  <div class="row">
    <div class="name">Unemployment Rate</div>
    <div class="value">
      {`${rate}%`}
    </div>
  </div>
</div>
